import React from 'react';
import { Placement } from '@philips-internal/oswald-ui-constants';
import { DeleteEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import ContextMenu from '../../context-menu/context-menu.js';
import { downloadImage } from '../../media-container/media-container-utils.js';
import { Option } from '../../option/option.js';
import { TextFontSize } from '../../text/text-constants.js';
import { Text } from '../../text/text.js';
import { GalleryType } from '../gallery-constants.js';
import './gallery-footer.css';
function OptionDetails(props) {
    if (!props.image) {
        return null;
    }
    return React.createElement(Option, { onClick: props.onDetailsClick, value: "tws.gallery.details" });
}
function OptionDownload(props) {
    const { image = '' } = props;
    if (!image) {
        return null;
    }
    return React.createElement(Option, { onClick: () => void downloadImage(image), value: "tws.gallery.download" });
}
function OptionDelete(props) {
    if (!isFunction(props.onDelete)) {
        return null;
    }
    return React.createElement(Option, { onClick: () => props.onDelete(new DeleteEvent({ id: props.id })), value: "tws.gallery.delete" });
}
function ContextMenuElement(props) {
    if ((!props.image && !isFunction(props.onDelete)) || props.selected) {
        return null;
    }
    return (React.createElement(ContextMenu, { placement: Placement.RIGHT },
        React.createElement(OptionDetails, { image: props.image, onDetailsClick: props.onDetailsClick }),
        React.createElement(OptionDownload, { image: props.image }),
        React.createElement(OptionDelete, { id: props.id, onDelete: props.onDelete })));
}
function GalleryFooter(props) {
    if (props.type === GalleryType.HOVER_CONTENT) {
        return null;
    }
    return (React.createElement("div", { className: "c-gallery-footer" },
        React.createElement("div", { className: "c-gallery-footer__text" },
            React.createElement(Text, { ellipsis: true, size: TextFontSize.SMALL, value: props.name }),
            React.createElement(Text, { ellipsis: true, formatters: { value: { name: 'date' } }, size: TextFontSize.SMALL, value: props.date })),
        React.createElement("div", { tabIndex: 2 },
            React.createElement(ContextMenuElement, { id: props.id, image: props.image, name: props.name, onDelete: props.onDelete, onDetailsClick: props.onDetailsClick, selected: props.selected }))));
}
export { GalleryFooter, };
//# sourceMappingURL=gallery-footer.js.map